/* eslint-disable @typescript-eslint/no-explicit-any */
import TabNav from "./components/tabNav";
import styles from "./reviews.module.scss";

import { useState, ReactElement, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import WaitingReview from "./components/waitingReview";
import ReviewComplete from "./components/reviewCompleted";
import { Helmet } from "react-helmet";
import { useOutletContext } from "react-router-dom";
import { sendPv, sendClickTrack as myReviewSendClickTrack, EXPOSURE_RECORD as MY_REVIEW_EXPOSURE_RECORD } from "@/tracks/25155"
interface ProfileListContext {
  initRecommendMainSkus: (mainSkus: string) => void;
}
const ReviewList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentTab = queryParams.get("tab");
  const [activeIndex, setActiveIndex] = useState<number>(currentTab ? parseInt(currentTab) : 0);
  const tabData = ["Awaiting review", "Reviewed"];
  const { initRecommendMainSkus } = useOutletContext<ProfileListContext>();
  const skuIdListFn = (value: any) => {
    initRecommendMainSkus(value);
  };

  useEffect(()=> {
    /** PV-我的评价页 */
    sendPv.My_Reviews();
  }, [])

  const contentMap: Record<string, ReactElement> = {
    "0": <WaitingReview key={0} skuIdListFn={skuIdListFn} />,
    "1": <ReviewComplete key={1} skuIdListFn={skuIdListFn} />,
  };

  // 接收父级传入的参数
  // initRecommendMainSkus("333,444,555");

  return (
    <div className={styles.reviewList}>
      <Helmet>
        <title>My Reviews | Joybuy</title>
        <meta
          name="description"
          content="Joybuy offers the best online shopping experience with fast shipping and delivery guarantee on all orders. Shop now for unbeatable deals on top-quality products."
        />
      </Helmet>
      <div className={styles.title_container}>
        <div className={styles.title}>My Reviews</div>
      </div>
      <div className="reviews-wrapper"
        /** tab曝光 */
        exptag={"exp|" + MY_REVIEW_EXPOSURE_RECORD.My_Reviews_Tab_Expo}
        data-exptag-json-param={JSON.stringify({tab_name: activeIndex == 0 ? "1" : "2"})}
        data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
      >
        <TabNav
          activeIndex={activeIndex}
          navList={["Awaiting review", "Reviewed"]}
          onChange={(index: number) => {
            myReviewSendClickTrack.My_Reviews_Tab({tab_name: index == 0 ? "1" : "2"});
            setActiveIndex(index)
          }}
        />
      </div>
      <div className={styles.reviewContentWrapper}>
        {/*  Waiting review content */}
        {/* banner 提示 */}
        {tabData.map((tab: string, index: number) => {
          return (
            <div key={index}>
              {activeIndex === index ? (
                <div className={styles.content} key={index}>
                  {contentMap[index]}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default ReviewList;
